import { get, pull } from 'lodash'
import { getImageData } from '@/helpers'
import { CONTRACT_STATUS } from '@/configs/constant'
import ContractApi from '@/api/contract-api'

export const getTableDataSource = (sourceDataList, contractDataList) => {
  const dataList = _prepareDataList(sourceDataList, contractDataList)
  const deletedDataList = _getDeletedDataList(sourceDataList, contractDataList)

  const tableDataList = [...dataList, ...deletedDataList]
  return tableDataList
}

const _prepareDataList = (sourceDataList, contractDataList) => {
  const contractTableDataList = sourceDataList.map((sourceData) => {
    const contractData = contractDataList.find(item => item.id === sourceData.id)

    if (contractData !== undefined) {
      return contractData
    }

    return sourceData
  })

  return contractTableDataList
}

const _getDeletedDataList = (sourceDataList, contractDataList) => {
  const deletedDataList = contractDataList.map((contractHotelData) => {
    const sourceData = sourceDataList.find(item => item.id === contractHotelData.id)

    if (sourceData === undefined) {
      return contractHotelData
    }
  })

  const result = pull(deletedDataList, undefined)
  return result
}

export const prepareDocumentData = (contractDetail, fileType) => {
  const companyLogoElementId = 'company-logo'
  const hotelLogoElementId = 'hotel-logo'
  const companyLogoData = getImageData(companyLogoElementId, true)
  const hotelLogoData = getImageData(hotelLogoElementId)
  const header = document.getElementById('contract-header').innerHTML
  const detail = document.getElementById('contract-detail').innerHTML
  const termsAndCondition = document.getElementById('terms-and-condition').innerHTML
  const contact = _getContactPersonData(contractDetail)
  const salePerson = _getSalePersonData(contractDetail)
  const data = {
    isPdf: (fileType === 'pdf') ? 1 : 0,
    companyLogo: companyLogoData,
    hotelLogo: hotelLogoData,
    header: header,
    detail: detail,
    termsAndCondition: termsAndCondition,
    contact: contact,
    salePerson: salePerson
  }

  return data
}

function _getContactPersonData (contractDetail) {
  const title = get(contractDetail, 'agent.contactPerson.title', '')
  const firstName = get(contractDetail, 'agent.contactPerson.firstName', '')
  const lastName = get(contractDetail, 'agent.contactPerson.lastName', '')
  const position = get(contractDetail, 'agent.contactPerson.position', '')

  const contactName = `${title} ${firstName} ${lastName}`
  const data = {
    name: contactName.trim(),
    position: position
  }

  return data
}
function _getSalePersonData (contractDetail) {
  const title = get(contractDetail, 'salePerson.title', '')
  const firstName = get(contractDetail, 'salePerson.firstName', '')
  const lastName = get(contractDetail, 'salePerson.lastName', '')
  const position = get(contractDetail, 'salePerson.position', '')
  const salePersonName = `${title} ${firstName} ${lastName}`
  const signature = getImageData('sale-person-signature', true)

  const data = {
    name: salePersonName.trim(),
    position: position,
    signature: signature
  }

  return data
}

export const updateContractStatus = async (id, status) => {
  const data = {
    id: id,
    status: status
  }

  const result = await ContractApi.updateStatus(data)

  return result
}

export const getDuplicateContractDetail = async (id) => {
  const result = await ContractApi.detail(id)
  const contractDetail = result.contractDetail
  const newContractData = {
    id: '',
    refCode: '',
    status: CONTRACT_STATUS.DRAFT
  }
  const duplicatedContractDetail = Object.assign({}, contractDetail, newContractData)

  return duplicatedContractDetail
}
